var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c(_vm.question.type,_vm._b({tag:"component",attrs:{"value":_vm.value,"expected-response":_vm.question.expectedResponse},on:{"change":_vm.handleChange}},'component',_vm.question.data,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }